import React, { FC } from "react";

import styles from "./logo.module.scss";

import { Icon } from "components/cosmos";

export const Logo: FC = () => {
  return (
    <div className={styles.root}>
      <div className={styles.brandIcon}>
        <Icon size={28} name={"navigation-bar-logo"} context={"brand"} />
      </div>
      <div className={styles.titleIcon}>
        <div className={styles.titleIconInner}>
          <Icon
            name={"logo-mode-bff"}
            preserveAspectRatio={"xMidYMid meet"}
            context={"brand"}
            size={40}
          />
        </div>
      </div>
    </div>
  );
};
